import { render } from "./TableNoExport2.vue?vue&type=template&id=1019e4ee&scoped=true"
import script from "./TableNoExport2.vue?vue&type=script&lang=js"
export * from "./TableNoExport2.vue?vue&type=script&lang=js"

import "./TableNoExport2.vue?vue&type=style&index=0&id=1019e4ee&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1019e4ee"]])

export default __exports__